import _ from 'underscore';

import SiteModal from './site-modal';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const modalId = 'cart-limit-modal';

const template =
  `<div class="modal {{ modalId }}" id="{{ modalId }}" tabindex="0" aria-label="Swatch order error modal">
    <div class="modal-overlay"></div>
    <div class="modal-panel">
      <div class="modal-inner">
        <div class="modal-content">
          <div class="container-fluid px-0">
            <div class="row">
              <div class="col-12 px-0">
                <div class="mb-4">{{ message }}</div>
                <button class="btn-primary close-modal-btn">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const templateVals = _.template(template);

const removeCartLimitModal = () => {
  const modalDiv = document.getElementById(modalId);
  if (modalDiv) {
    modalDiv.remove();
  }
};

const addCartLimitModal = (options) => {
  const {
    message,
  } = options;
  const body = document.querySelector('body');
  const div = document.createElement('div');
  const compiled = templateVals({
    message,
    modalId,
  });
  div.innerHTML = compiled;
  body.appendChild(div.firstChild);

  let modal = new SiteModal({
    id: modalId,
    callbacks: {
      onClose: () => {
        removeCartLimitModal(modal);
        modal = null;
      },
    },
  });
  modal.open();
};

export default addCartLimitModal;
